<template>
  <div class="c-preview-teacher">
    <p class="c-preview-teacher-title">讲师介绍</p>
    <div class="c-preview-teacher-info">
      <img :src="teacherInfo.thumb" alt="">
      <p v-if="teacherInfo.title" class="c-preview-teacher-info-name">{{teacherInfo.title}}</p>
      <p v-if="teacherInfo.reason" class="c-preview-teacher-info-title">{{teacherInfo.reason}}</p>
      <p v-if="teacherInfo.content" class="c-preview-teacher-info-des">{{teacherInfo.content}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['teacherInfo'],
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.c-preview-teacher{
  text-align: center;
  padding-bottom: 100px;
  padding-top: 140px;
  .c-preview-teacher-title{
    line-height: 48px;
    font-size: 36px;
    margin-bottom: 88px;
  }
  .c-preview-teacher-info{
    height: 404px;
    width: 734px;
    box-sizing: border-box;
    margin: 0 auto;
    border: 1px solid #EFEFEF;
    border-radius: 23px;
    padding: 44px;
    img{
      text-align: center;
      margin-top: -77px;
      margin-bottom: 14px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      display: inline-block;
      border-radius: 50%;
      
    }
    .c-preview-teacher-info-name{
      color: #000000;
      line-height: 24px;
      margin-bottom: 8px;
    }
    .c-preview-teacher-info-title{
      line-height: 20px;
      font-size: 14px;
      margin-bottom: 25px;
      color: #7A7D80;
    }
    .c-preview-teacher-info-des{
      color: #7A7D80;
      line-height: 26px;
      font-size: 14px;
      max-height: 108px;
      overflow: hidden;
    }
  }
}
</style>
